<div class="dialog-container" >
  <div class="dialog-container-header">
  <div class="dialog-actions">
    <ng-container [ngTemplateOutlet]="data.actions"
                  [ngTemplateOutletContext]="{close: onCloseClick.bind(this)}">
    </ng-container>
  </div>
  </div>
  <div class="dialog-content">
    <ng-container [ngTemplateOutlet]="data.content"></ng-container>
  </div>

</div>
